var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKanbanIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0C19.1046 0 20 0.895431 20 2V7V18C20 19.1046 19.1046 20 18 20H13C11.8954 20 11 19.1046 11 18V2C11 0.895432 11.8954 0 13 0H18ZM18 2H13V18H18V7V2ZM7 0C8.10457 0 9 0.89543 9 2V3.33333V7C9 8.10457 8.10457 9 7 9H2C0.895432 9 0 8.10457 0 7V2C0 0.89543 0.895432 0 2 0H7ZM7 2L2 2V7L7 7V3.33333V2Z",
    fill: "#B1ADA2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKanbanIcon);
export default __webpack_public_path__ + "static/media/kanbanIcon.3b45e130789c5ca006aa1008d0442fa9.svg";
export { ForwardRef as ReactComponent };